<template>
  <form @submit.prevent="save">
    <v-alert error :value="!!error"><span v-html="error"></span></v-alert>

    <password-input
      ref="password"
      v-model="passwords.updated"
      :options="{}"
      :label="$t('profile.password.newPassword')"
      :model="passwords"
      :min-level="complexity"
    />

    <password-input
      ref="passwordAgain"
      v-model="passwords.updated2"
      :options="{ otherPassword: 'updated' }"
      :label="$t('profile.password.newPasswordAgain')"
      :model="passwords"
      :min-level="complexity"
    />

    <v-card-actions>
      <v-btn type="submit">{{ $t('save') }}</v-btn>
    </v-card-actions>
  </form>
</template>

<script>
import PasswordInput from '@/components/PasswordInput'

export default {
  props: {
    error: String,
    complexity: Number
  },
  data () {
    return {
      passwords: {
        updated: null,
        updated2: null
      }
    }
  },
  methods: {
    save () {
      if (!this.$refs.password.isValid() || !this.$refs.passwordAgain.isValid()) {
        return
      }

      this.$emit('save', this.passwords.updated)
    }
  },
  components: {
    PasswordInput
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// PasswordForm.vue?b65ddbba